
const links = [
    {
        label: 'Instagram',
        url: "https://instagram.com/nutricharlinetormen"
    },
    {
        label: 'Facebook',
        url: "https://www.facebook.com/nutricharlinetormen"
    },
    {
        label: 'Twitter',
        url: "https://twitter.com/nutricharline"
    },
    {
        label: 'Youtube',
        url: "https://www.youtube.com/channel/UCLPtZokCMhd_M9ZZV8wloog"
    }
];

export default links;